import { render, staticRenderFns } from "./BoardPostBaseList.vue?vue&type=template&id=711c098c&scoped=true"
import script from "./BoardPostBaseList.vue?vue&type=script&lang=js"
export * from "./BoardPostBaseList.vue?vue&type=script&lang=js"
import style0 from "./BoardPostBaseList.vue?vue&type=style&index=0&id=711c098c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711c098c",
  null
  
)

export default component.exports